import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePodcastPreviewQuery = createQueryHook(
  MembershipsSpotifyIntegrationsApiClient.getPodcastPreview,
  { queryKey: ['podcastPreview'] },
)
